import React from "react";
import './style.css';
import SkillBar from 'react-skillbars';

function SkillsBar () {


    const skills = [
        { type: 'HTML', level: 90 },
        { type: 'CSS', level: 85 },
        { type: 'JAVASCRIPT', level: 80 },
        { type: 'JQUERY', level: 70 },
        { type: 'BOOTSTRAP', level: 80 },
        { type: 'REACT.JS', level: 85},
        { type: 'NODE.JS', level: 65 },
        { type: 'PHP', level: 78 },
        { type: 'MYSQL', level: 75 },
        { type: 'MONGODB', level: 65 },
        { type: 'CODEIGNITER', level: 80 },
        { type: 'EXPRESS.JS', level: 72 },
      ];
      const colors = {
        bar: "rgb(10 163 100)",
        title: {
          text: "#fff",
          background: "#00693e"
        }
    }
   return (
    <SkillBar skills={skills} colors={colors} />
   )
}

export default SkillsBar;